
import Vue, { PropType } from 'vue';
import TheApp from './TheApp.vue';
import { ProductColorSetterType } from '@/setters/typings/common/ProductColorsSetterType';

export default Vue.extend({
  name: 'SwitchColor',
  components: { TheApp },

  props: {
    productVariants: {
      type: [] as PropType<ProductColorSetterType[]>,
      required: true,
    },
  },
  computed: {
    filteredVariants(): ProductColorSetterType[] {
      let filteredVariants: ProductColorSetterType[] = [];
      if (this.productVariants) {
        this.productVariants.map((variant: ProductColorSetterType) => {
          if (filteredVariants.length === 0) {
            filteredVariants.push(variant);
          }

          let checkExistingVariant = filteredVariants.find((filtered) => {
            return filtered.colorHex === variant.colorHex;
          });
          if (!checkExistingVariant) {
            filteredVariants.push(variant);
          }
        });
      }
      return filteredVariants;
    },
  },
});
